import { useCallback } from 'react';

import { type ApiKey } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAccountApiKeyDelete.meta';

export type UseTrackAccountApiKeyDeleteParams = {
  api_key_id: ApiKey['id'];
};

export const useTrackAccountApiKeyDelete = () => {
  const { track } = useAnalyticsUtilities();

  const trackAccountApiKeyDelete = useCallback(
    (params: UseTrackAccountApiKeyDeleteParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAccountApiKeyDelete };
};
